import './Footer.css'

const instargram = require('./icons/instagram.png')
const youtube = require('./icons/youtube.png')
const telegram = require('./icons/telegram.png')

function Footer() {
    return (
        <section className='footer'>
            <div className='footer__icons'>
                <a href=""><img src={instargram} alt=""/></a>
                <a href="https://www.youtube.com/@rubber-dev"><img src={youtube} alt=""/></a>
                <a href="https://t.me/qrren"><img src={telegram} alt=""/></a>
            </div>
        </section>
    )
}

export default Footer